var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import classnames from 'classnames';
import styles from './Game.module.css';
var GameCanvas = function (props) {
  var _a, _b, _c;
  var id = props.id,
    iframeSourceCode = props.iframeSourceCode,
    onIframeLoad = props.onIframeLoad,
    iframeRef = props.iframeRef,
    isIframeGame = props.isIframeGame,
    game = props.game,
    isArkadiumSdkGame = props.isArkadiumSdkGame,
    onSdkIframeLoad = props.onSdkIframeLoad;
  if (isIframeGame || isArkadiumSdkGame) {
    return React.createElement("div", {
      className: classnames.apply(void 0, __spreadArray(['game', props.topLevelClassname, styles.canvasBoxWrapper], (_a = props.customCssClassesCanvasBoxWrapper) !== null && _a !== void 0 ? _a : [], true)),
      "aria-hidden": "true",
      id: id
    }, React.createElement("iframe", {
      src: iframeSourceCode || undefined,
      "aria-label":
      // fixes #147915 - used instead of title that is visible on hover
      'canvas box for game',
      id: "canvas-box",
      className: classnames.apply(void 0, __spreadArray(['game', styles.canvasBox], (_b = props.customCssClassesCanvasBox__iframe) !== null && _b !== void 0 ? _b : [], true)),
      ref: iframeRef,
      onLoad: isArkadiumSdkGame ? onSdkIframeLoad : onIframeLoad,
      allow: "clipboard-read *; clipboard-write *;"
    }));
  } else {
    return React.createElement("div", {
      className: classnames.apply(void 0, __spreadArray([props.topLevelClassname, styles.canvasBox], (_c = props.customCssClassesCanvasBox__common) !== null && _c !== void 0 ? _c : [], true)),
      "aria-hidden": "true",
      id: id,
      style: (game === null || game === void 0 ? void 0 : game.height) ? {
        height: "".concat(game.height, "px")
      } : {}
    });
  }
};
GameCanvas.displayName = 'GameCanvas';
var MemoizedGameCanvas = React.memo(GameCanvas);
export { MemoizedGameCanvas as GameCanvas };